import React, {FC} from 'react';

type UIModalProps = {
  message: string;
}

const UIModal: FC<UIModalProps> = ({message}) => {
  return (
    <div className='fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto
     flex z-30 items-center justify-center h-full w-full'>
      <div className='px-8 md:px-36 py-5 md:py-10 shadow-medium-card rounded-2xl bg-white'>
        <div className="font-Outfit text-lg md:text-xl font-medium text-center">{message}</div>
      </div>
    </div>
  );
};

export default UIModal;
